import './FeedbackForm.scss'

import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'react-fa'
import { FEEDBACKTYPE_POSITIVE } from '../../constants/feedbackConstants'
import LocalizedString from '../LocalizedString'

const FeedbackForm = (props, context) => {
  const iconName = props.feedback.feedbackType === FEEDBACKTYPE_POSITIVE ? 'thumbs-up' : 'thumbs-down'
  let commentInput
  const onSubmit = e => {
    e.preventDefault()
    props.onSubmit(commentInput.value.trim(), props.feedback.feedbackType)
  }

  return props.feedback.showFeedback && (
    <div className='user-feedback'>
      <div className='sub-header feedback-header promptable-area-with-actions'>
        <div className='feedback-form flex-column padded-sides'>
          <div className='flex-column'>
            <div className='flex-row'>
              <div className='spacer-for-non-mobile' />
              <div className='feedback-title'><Icon name={iconName} />
                <LocalizedString resourceKey='common.Label_Feedback' />
              </div>
            </div>
            <textarea maxLength={3500} ref={ el => commentInput = el } />
            <div className='flex-row vertical-centered-items align-self-end'>
              <button
                className='cp-button secondary'
                type='button'
                onClick={props.onCancel}>
                <LocalizedString resourceKey='common.Button_Cancel' />
              </button>
              <button
                className='cp-button submit-button gutter-left'
                type='button' onClick={onSubmit}>
                <LocalizedString resourceKey='common.Button_Submit' />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

FeedbackForm.propTypes = {
  onSubmit: PropTypes.func,
  feedback: PropTypes.object,
  onCancel: PropTypes.func
}

export default FeedbackForm



// WEBPACK FOOTER //
// ./src/components/FeedbackForm/FeedbackForm.js